export const BUSINESS_ACHIEVEMENTS = [
  {
    img: "https://cdn.dotpe.in/longtail/custom_website/7612844/i42PGmZ3.png",
    title: "Tech startup of the year",
  },
  {
    img: "https://cdn.dotpe.in/longtail/custom_website/7612844/6Fj9BWju.png",
    title: "Backed by Google",
  },
  {
    img: "https://cdn.dotpe.in/longtail/custom_website/7612844/bWbnqNUi.png",
    title: "Official partner",
  },
  {
    img: "https://cdn.dotpe.in/longtail/custom_website/7612844/RSgAn7Vx.png",
    title: "Top 20 startups of the year",
  },
];

export const CUSOMER_SUPPORT_CONTACT_DETAILS = "011 - 69039069";

export const DROPDOWN_OPTIONS = [
  "I am starting a new business",
  "I have existing offline business",
  "I am just exploring",
];
export const CHECKBOX_OPTIONS = ["Domain purchase", "Building a website", "General Query"];
export const RANGE = {
  MOBILE: 10,
  OTP: 4,
};
export const SOURCE_CONSTANT = {
  REQUEST_TO_CALLBACK: "RequestToCallBackPage",
  OTP_CALLBACK_REQUEST: "otpCallBackrequest",
  INPUT_CALLBACK_REQUEST: "inputCallBackRequest",
  MOBILE_NO: "mobileNo",
  NAME: "name",
  BUSINESS_TYPE: "businessType",
  QUERY_REASON: "queryReason",
  REMOVE_QUERY: "removeQueryReason",
  OTP: "otp",
};
export const INPUT_PLACEHOLDER = {
  MOBILE:"Enter Mobile Number *",
  NAME: "Your Name *",
  OTP: "Enter 4 digit OTP",
};
